<template>
  <div class="page page2 tg-group">
    <!-- <van-form @submit="submitForm"> -->
    <van-form @submit="submitForm">
      <div class="top-tips">
        <img class="icon-tips" :src="bgImg[0]" />
        <p>
          您正在进行组照投稿，请上传<span class="o"
            >{{ gourp_limit.start }}-{{ gourp_limit.end }}</span
          >幅专题作品并添加相应描述。
        </p>
      </div>
      <div class="main-info">
        <van-field
          class="required"
          v-model="form.mname"
          name="作品标题"
          label="作品标题"
          maxlength="15"
          placeholder="请输入作品标题，15字以内"
          :rules="[{ required: true, message: '作品标题不能为空' }]"
        />
        <van-field
          class="required"
          v-for="(item, index) in custom_fields"
          v-model="form.custom_fields[index]"
          :key="index"
          :name="item"
          :label="item"
          :placeholder="'请输入' + item"
          :rules="[{ required: true, message: item + '不能为空' }]"
        />
        <van-field
          v-model="form.shoot_address"
          name="作品拍摄地"
          label="作品拍摄地"
          v-if="gourp_limit.is_open_psd == 1"
          placeholder="请输入作品拍摄地"
        />
        <van-field
          class="required"
          v-model="form.shoot_address"
          name="作品拍摄地"
          label="作品拍摄地"
          v-if="gourp_limit.is_open_psd == 2"
          placeholder="请输入作品拍摄地"
          :rules="[{ required: true, message: '作品拍摄地不能为空' }]"
        />
        <van-field
          v-model="form.remark"
          name="作品描述"
          label="作品描述"
          maxlength="250"
          placeholder="请输入作品描述"
        />
      </div>
      <div class="main">
        <div class="item item-req">
          <div class="label">作品上传</div>
        </div>
        <div class="upload-wrap">
          <van-uploader
            ref="uploadFile"
            class="upload-wrap"
            v-model="fileList"
            :after-read="handleUpload"
            :before-read="beforeUpload"
            :maxCount="maxCount"
            multiple
            v-show="false"
          ></van-uploader>
          <div
            class="upload-wrap"
            @click="chooseFromSys"
            v-show="isShowUploader1"
          >
            <div class="upload">
              <a class="btn-upload" href="javascript:;">
                <img :src="bgImg[1]" />
                <p>点击上传作品</p>
              </a>
              <!-- <input type="file" class="file" /> -->
            </div>
          </div>
        </div>

        <ul class="list" v-show="!isShowUploader1">
          <li
            v-for="(item, index) in form.imgs"
            :key="index"
            @click="getIndex(index)"
          >
            <div class="pic-wrap">
              <van-uploader
                class="upload-wrap"
                :after-read="handleUploadSingle"
                :before-read="beforeUpload"
                :max-count="1"
              >
                <div class="pic-wrap1">
                  <img class="pic" :src="item.url" />
                  <van-loading
                    size="24px"
                    type="spinner"
                    vertical
                    v-show="
                      fileList[index] &&
                        fileList[index].status &&
                        fileList[index].status == 'uploading'
                    "
                    >上传中...</van-loading
                  >
                </div>
              </van-uploader>
              <!-- <img class="pic" :src="img.url" /> -->
              <span class="id">{{ index + 1 }}</span>
              <div class="btn-wrap">
                <a
                  class="del"
                  href="javascript:void(0)"
                  @click="delFindingItem(index)"
                  v-show="form.imgs.length > 1"
                  ><i></i>删除</a
                >
                <a
                  class="up"
                  href="javascript:void(0)"
                  @click="moveUp(index)"
                  v-show="index > 0"
                  ><i></i>上移</a
                >
                <a
                  class="down"
                  href="javascript:void(0)"
                  @click="moveDown(index)"
                  v-show="index < form.imgs.length - 1"
                  ><i></i>下移</a
                >
              </div>
            </div>
            <van-field
              class="required"
              v-model="item.title"
              name="作品标题"
              label="作品标题"
              maxlength="15"
              :placeholder="imgTitle"
              :rules="[{ required: false, message: ' ' }]"
            />
            <van-field
              v-model="item.describe"
              name="作品描述"
              label="作品描述"
              maxlength="250"
              placeholder="请添加250字以内的作品描述"
            />
          </li>
        </ul>
        <!-- <div class="upload2" v-show="!isShowUploader1" @click="newUpload"> -->
        <div
          class="upload2"
          v-show="!isShowUploader1 && this.form.imgs.length < maxCount"
          @click="chooseFromSys"
        >
          <div class="upload-wrap">
            <div class="upload">
              <a class="btn-upload" href="javascript:;">
                <img :src="bgImg[1]" />
                <p>点击继续上传作品</p>
              </a>
              <!-- <input type="file" class="file" onChange="addImg()" /> -->
              <!-- <input type="file" class="file" /> -->
              <!-- <van-loading
                size="24px"
                color="#dd855c"
                vertical
                v-show="loading[current + 1]"
                >上传中...</van-loading
              > -->
            </div>
          </div>
        </div>
      </div>
      <div class="tips" v-if="msg != ''">
        {{ msg }}
      </div>
      <div class="agree">
        <label @click="changeSync">
          <input class="check" type="checkbox" :checked="form.is_app_show" />
          <div class="text" @click.stop>
            我同意将该图片同步到App-发现中，发布即同意<a
              href="https://www.pai2345.com/wap/treaty/index/id/9"
              >千途原创条款</a
            >。
          </div>
        </label>
      </div>
      <div class="bottom">
        <a href="javascript:;" @click="goMatchDetail">返回赛事首页</a>
        <van-button
          class="submit"
          block
          type="warning"
          native-type="submit"
          @click="beforeSubmit"
        >
          保存并提交
        </van-button>
        <!-- <a class="submit" href="">保存并提交</a> -->
      </div>
    </van-form>
  </div>
</template>

<script>
// import ChooseFile from "@/components/ChooseFile";
export default {
  // components: {
  //   ChooseFile,
  // },
  data() {
    return {
      uploadBg: require("@/static/images/1223/btn-add.png"),
      bgImg: [
        require("@/static/images/group/i-1.png"),
        require("@/static/images/group/i-8.png"),
      ],
      loading: [false],
      // dialogImageUrl: "",
      // dialogVisible: false,
      id: this.$route.params.id,
      group: this.$route.query.group,
      define: [],
      // form
      form: {
        work_id: this.$route.query.work_id,
        match_id: this.$route.params.id,
        mname: "",
        remark: "",
        imgs: [
          { url: "", title: "", describe: "" },
          // {
          //   id: "",
          //   title: "",
          //   describe: "",
          //   url: "",
          //   percent: false,
          // },
        ],
        group: this.$route.query.group,
        shoot_address: "",
        custom_fields: [],
        // 是否同意条款
        is_app_show: 0,
        is_finding: 0,
        works_type: 3,
      },
      imgs: [
        {
          title: "",
          describe: "",
          url: "",
        },
      ],
      // rules: {
      //   mname: [
      //     { required: true, message: "作品名称不能为空", trigger: "blur" }
      //   ],
      //   remark: [{ message: "作品描述不能为空", trigger: "blur" }]
      // },
      // 自定义字段
      custom_fields: [],
      // 上传列表
      list: [
        {
          id: "",
          title: "",
          describe: "",
          url: require("@/static/res/images/0905/picbg.png"),
          percent: 0,
        },
      ],
      domIdx: 0,
      //图片的限定
      gourp_limit: {
        typestr: "",
        size: 20,
        end: 2,
        start: 2,
        imgtype: [],
        is_open_psd: 0,
      },
      // 是否同意发布到app
      is_app_show: 0,
      msg: "",
      current: 0,
      isUploadeds: false,
      // 是否默认上传
      isShowUploader1: true,
      // 是否新增上传
      isAdd: false,
      has_submit: true,
      fileList: [{ file: "" }],
      maxCount: 1,
    };
  },
  computed: {
    imgTitle: function() {
      if (this.form.mname) {
        return this.form.mname;
      } else {
        return "请输入图片标题，15字以内";
      }
    },
  },
  methods: {
    chooseFromSys() {
      this.$refs.uploadFile.chooseFile();
    },
    newUpload() {
      // 新增上传
      this.isAdd = true;
      this.current = this.form.imgs.length;
    },
    // 是否同步app
    changeSync() {
      this.form.is_app_show = !this.form.is_app_show;
    },
    // 获取上传图的索引，定位正在对哪个上传图片进行操作
    getIndex(index) {
      this.current = index;
      this.isAdd = false;
      // console.log(index);
    },
    // 校验图片是否符合限制
    valid(file) {
      let isJPG = this.tools.hasImgType(this.gourp_limit.imgtype, file.type);
      let isLt2M = file.size / 1024 / 1024 < this.gourp_limit.size;
      if (!isJPG) {
        this.$toast.fail({
          message: "上传图片只能是 " + this.gourp_limit.typestr + " 格式!",
          duration: 3500,
          className: "long-toast",
        });
        return false;
      }
      if (!isLt2M) {
        this.$toast.fail(
          "上传图片大小不能超过 " + this.gourp_limit.size + "MB!"
        );
        return false;
      }
      return isJPG && isLt2M;
    },
    // 图片上传前处理
    beforeUpload(file) {
      console.log("reUpload：", file);
      if (typeof file == "object" && file.length > 0) {
        let result = file.filter((item) => {
          return this.valid(item);
        });
        if (result.length == file.length) {
          this.isShowUploader1 = false;
        }
        // 数组过滤后长度不等于原先的，说明有文件不符合预期，不上传
        return result.length == file.length;
      } else {
        if (this.valid(file)) {
          this.isShowUploader1 = false;
        }
        return this.valid(file);
      }
    },
    // 图片上传事件抽象
    upload(file) {
      // var file = option.file;
      var _file = file.file;
      file.status = "uploading";
      file.message = "上传中...";
      // console.log("uploading: ", file.file);
      // 传图前，loading状态
      let length = this.form.imgs.length;
      this.form.imgs[length] = { url: file.content };
      // 传图失败，减少imgs长度
      this.tools
        .uploadaly(_file)
        .then((res) => {
          if (res) {
            // this.form.imgs[this.current].url = res;
            // this.form.imgs[this.current].percent = false;
            this.form.imgs[length].url = res;
            file.status = "";
            file.message = "";
          }
        })
        .catch((err) => {
          console.log(err);
          this.form.imgs.pop();
          file.status = "fail";
          file.message = "上传失败";
        });

      // console.log(this.form.imgs);
      // console.log(this.fileList);
    },
    handleUploadSingle(file) {
      var _file = file.file;
      // 传图前，loading状态
      let index = this.current;
      // let oldImg = this.form.imgs[index].url;
      this.fileList[index].status = "uploading";
      this.form.imgs[index] = { url: file.content };
      // console.log(this.current);
      // 传图失败，减少imgs长度
      this.tools
        .uploadaly(_file)
        .then((res) => {
          if (res) {
            this.form.imgs[index].url = res;
            this.fileList[index].status = "";
            this.$forceUpdate();
            console.log(this.form.imgs);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.form.imgs.splice(index, 1);
          // file.status = "fail";
          // file.message = "上传失败";
        });
    },
    // 图片上传实际函数
    handleUpload(files) {
      console.log(files);
      if (typeof files == "object" && files.length > 0) {
        for (let file of files) {
          this.upload(file);
        }
      } else {
        this.upload(files);
      }
    },
    goMatchDetail() {
      this.$router.push({
        path: "/detail/" + this.id + "/intro",
      });
    },
    delFindingItem: function(index) {
      this.form.imgs.splice(index, 1);
    },
    moveUp: function(index) {
      let obj = this.form.imgs[index - 1];
      this.form.imgs[index - 1] = this.form.imgs[index];
      this.form.imgs[index] = obj;
      this.$forceUpdate();
    },
    moveDown: function(index) {
      let obj = this.form.imgs[index + 1];
      this.form.imgs[index + 1] = this.form.imgs[index];
      this.form.imgs[index] = obj;
      this.$forceUpdate();
    },
    del_obj: function() {
      if (this.list.length > 1) {
        for (let i = this.list.length - 1; i >= 0; i--) {
          if (this.list[i].percent < 1) {
            this.list.splice(i, 1);
          }
        }
      }
    },
    beforeSubmit() {
      // 如果作品标题不为空，则新增的图片标题可以默认标注
      if (this.form.mname != "" && !this.isShowUploader1) {
        for (let i = 0, len = this.form.imgs.length; i < len; i++) {
          if (!this.form.imgs[i].title || this.form.imgs[i].title == "") {
            this.form.imgs[i].title = this.form.mname + " (" + (i + 1) + ")";
          }
          if (!this.form.imgs[i].describe) {
            this.form.imgs[i].describe = "";
          }
        }
        console.log(this.form, this.isShowUploader1);
      }
    },
    submitForm() {
      // let that = this;
      if (!this.$store.state.isLogin) {
        /* eslint-disable */
        // 调用passport
        passportLogin.login();
        /* eslint-enable */
        return false;
      }
      if (this.has_submit) {
        this.has_submit = false;
        var fase = true;

        if (this.form.imgs.length == 0) {
          this.$toast.fail("请先上传图片");
          fase = false;
        }
        if (this.gourp_limit.start == 0) {
          this.gourp_limit.start = 2;
        }
        if (this.form.imgs.length < this.gourp_limit.start) {
          this.$toast.fail({
            message:
              "本次投稿需要上传至少 " +
              this.gourp_limit.start +
              " 张图片\n请调整后重试！",
            duration: 5000,
            className: "long-toast",
          });
          fase = false;
        }
        // if (this.loading) {
        //   // this.$message.error("图片上传中，请稍候...");
        //   console.log("图片上传中");
        //   fase = false;
        // }
        if (this.gourp_limit.is_open_psd == 2) {
          if (this.form.shoot_address == "") {
            this.$toast.fail("图片拍摄地必须填写");
            fase = false;
          }
        }
        if (fase) {
          this.form.is_finding = this.form.is_app_show;
          this.axios
            .post("/match/join_multi", {
              ...this.form,
            })
            .then(
              (res) => {
                if (res.data.code == 200) {
                  if (this.form.work_id > 0) {
                    // 作品的再投一稿
                    this.$router.push({
                      query: {
                        group: this.group,
                      },
                    });
                  }
                  this.$dialog
                    .confirm({
                      title: "",
                      message: "投稿成功!",
                      confirmButtonText: "再投一稿",
                      cancelButtonText: "返回赛事页",
                    })
                    .then(() => {
                      // on confirm
                      window.location.reload();
                    })
                    .catch((action) => {
                      // on cancel
                      console.log(action);
                      this.$router.push({
                        name: "intro",
                      });
                    });
                } else {
                  // this.$toast.fail(res.data.msg);
                  this.$toast.fail({
                    message: res.data.msg,
                    duration: 3500,
                    className: "long-toast",
                  });
                }
                this.has_submit = true;
                console.log(res);
              },
              (err) => {
                this.has_submit = true;
                console.log(err);
              }
            );
        } else {
          this.has_submit = true;
        }
      }
    },
  },
  created() {
    // data中设置fileList首元素为空内容 触发响应数据
    // 开始操作前把内容清空
    this.fileList = [];
    this.form.imgs = [];
  },
  mounted() {
    // 每次加载都清空图库选择状态
    sessionStorage.removeItem("checkVal");
    // 获取比赛详情
    this.tools
      .getMatchDetail({ id: this.id, group: this.group })
      .then((res) => {
        console.log(res);
        // this.define = res.custom_fields;
        this.custom_fields = res.custom_fields;
        this.msg = res.match_limit.match_introduce;
        this.form.is_app_show = res.match_limit.is_app_show;
        var params = res.gourp_limit;
        if (params) {
          this.gourp_limit = Object.assign(this.gourp_limit, params);
          this.gourp_limit.size = params.file_limit;
          this.gourp_limit.imgtype = params.file_limit_type;
          this.gourp_limit.typestr = this.gourp_limit.imgtype.toString();
          this.gourp_limit.start = params.start == 0 ? 2 : params.start;
          this.gourp_limit.end = params.end;
          this.maxCount = this.gourp_limit.end == 0 ? 15 : this.gourp_limit.end;
        }
      });
    if (this.$route.query.work_id) {
      this.tools
        .getWorksDetail({ work_id: this.$route.query.work_id })
        .then((res) => {
          // this.form = res.form;
          Object.assign(this.form, res.form);
          // this.fileList = res.fileList;
          this.form.imgs = res.imgs;
          for (let i = 0, length = res.imgs.length; i < length; i++) {
            this.form.imgs[i].percent = this.form.imgs[i].percent != 2;
          }
          this.isShowUploader1 = false;
        });
    }
  },
};
</script>

<style lang="scss">
.tg-group {
  .main-info {
    padding: 0;
    height: auto;
  }
  .choose-file {
    position: relative;
    z-index: 11;
  }
  .upload-wrap {
    position: relative;
    .input-wrap {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  textarea {
    word-break: break-all;
    word-wrap: break-word;
  }
  .van-uploader__upload,
  .van-uploader__preview {
    margin: 0 30px 30px 0;
    width: 210px;
    height: 210px;
  }

  .van-uploader__preview-image {
    width: 210px;
    height: 210px;
  }
  .van-field__label {
    width: 180px;
  }
  .required {
    .van-field__label {
      span::after {
        content: "*";
        color: #dd855c;
        position: absolute;
        left: 18px;
        top: 30px;
      }
    }
  }
  .van-uploader,
  .van-uploader__input-wrapper,
  .van-uploader__wrapper,
  .pic-wrap1 {
    width: 100%;
    height: 100%;
  }
  .van-button {
    // line-height: 1;
  }
  .van-loading {
    background: rgba(0, 0, 0, 0.4);
    height: 100%;
    span {
      position: relative;
      top: 40%;
      color: #fff;
    }
  }
  .van-button {
    display: flex;
    width: 50%;
    padding: 0;
    text-align: center;
    .van-button__text {
      display: block;
      margin: 0 auto;
    }
  }
  .bottom {
    padding: 0;
  }
}
.list li .pic-wrap .pic {
  z-index: auto;
}
.main .upload2 {
  border-width: 2px; /* no */
}
.long-toast {
  width: 80%;
  max-width: 80%;
}
</style>
